import React, { useState } from 'react';
import { Button, Popover } from 'antd'; // Import your UI library components
import { FileZipOutlined, DownloadOutlined } from '@ant-design/icons'; // Import the required icons
import { downloadDocuments, downloadDocumentsUnzip, downloadFlooringDocuments, downloadFlooringDocumentsUnzip } from '../../common/Utilities';

const DownloadButton = ({ type, label, icon, onClick }) => (
  <Button
    type="primary"
    onClick={() => onClick(type)}
    className="min-[768px]:text-[14px] max-[768px]:text-[12px] bg-white flex w-[155px] mb-2"
  >
    {icon && React.cloneElement(icon, { className: 'mr-2 mt-1' })}
    <p>{label}</p>
  </Button>
);

const CustomDownloadComponent = ({ type, appId, formType }) => {
  const [downloadPopOver, setDownloadPopOver] = useState(false);

  const handleOpenChange = (newOpen) => {
    setDownloadPopOver(newOpen);
  };

  // const buttons = [
  //   {
  //     label: 'Download Zip',
  //     icon: <FileZipOutlined />,
  //     onClick: downloadFlooringDocuments("Flooring", appId),
  //   },
  //   {
  //     label: 'Download Files',
  //     icon: <DownloadOutlined />,
  //     onClick: downloadFlooringDocuments("Flooring", appId),
  //   },
  // ];


  return (
    <div className="justify-between items-center mb-2">
      <Popover
        content={
          // <div>
          //   {buttons.map((button, index) => (
          //     <DownloadButton key={index} {...button} />
          //   ))}
          // </div>
          <div>
            <Button
              type="primary"
              onClick={() => {
                downloadFlooringDocuments(type, appId, formType);
              }}
              className="min-[768px]:text-[14px] max-[768px]:text-[12px] bg-white flex w-[155px] mb-2"
            >
              <FileZipOutlined className="mr-2 mt-1" />
              <p>Download Zip</p>
            </Button>
            <Button
              type="primary"
              onClick={() => {
                downloadFlooringDocumentsUnzip(type, appId, formType);
              }}
              className="min-[768px]:text-[14px] max-[768px]:text-[12px] bg-white flex w-[155px]"
            >
              <DownloadOutlined className="mr-2 mt-1" />
              <p>Download Files</p>
            </Button>
          </div>
        }
        placement="bottom"
        trigger="click"
        open={downloadPopOver}
        onOpenChange={handleOpenChange}
      >
        <Button className="min-[768px]:text-[14px] max-[768px]:text-[12px]" type="primary">
          Download All Documents
        </Button>
      </Popover>
    </div>
  );
};

export default CustomDownloadComponent;
